import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home.vue'
import NotFound from './views/NotFound';
import ModeService from './services/ModeService';

Vue.use(VueRouter);

const Router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      props: route => ({
        posToken: route.query.posToken || route.query.kioskToken
      }),
      component: Home,
      beforeEnter: (to, from, next) => {
        if (ModeService.getEventCode()) {
          // Directly to event
          next({
            name: 'booking',
            params: {
              code: ModeService.getEventCode()
            }
          })
        }

        next()
      }
    },
    {
      path: '/event/:code',
      props: true,
      component: () => import(/* webpackChunkName: "booking" */ './views/Booking.vue'),
      children: [
        {
          path: '',
          name: 'booking',
          props: true,
          component: () => import(/* webpackChunkName: "booking" */ './views/Periods.vue'),
        },
        {
          path: 'zones',
          name: 'zones',
          props: true,
          component: () => import(/* webpackChunkName: "booking" */ './views/Zones.vue'),
        },
        {
          path: 'lockers',
          name: 'lockers',
          props: true,
          component: () => import(/* webpackChunkName: "booking" */ './views/Lockers.vue'),
        },
        {
          path: 'details',
          name: 'details',
          props: true,
          component: () => import(/* webpackChunkName: "booking" */ './views/Details.vue'),
        },
        {
          path: 'payment',
          name: 'payment',
          props: true,
          component: () => import(/* webpackChunkName: "booking" */ './views/Payment.vue'),
        }
      ]
    },
    {
      path: '/confirmation/:token',
      name: 'confirmation',
      props: true,
      component: () => import(/* webpackChunkName: "confirmation" */ './views/Confirmation.vue'),
    },
    {
      path: '*',
      name: 'notfound',
      component: NotFound
    }
  ]
});

/**
 * Does this route has query parameters?
 *
 * @param {Object} route
 * @returns {Boolean}
 */
function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

// Preserve query parameters
Router.beforeEach((to, from, next) => {
  if (!hasQueryParams(to) && hasQueryParams(from)) {
    next({...to, query: from.query});
  } else {
    next();
  }
});

export default Router;
